import * as React from 'react'

// Components
import { Link } from 'components/link'

// Config
import { choosePlan } from 'config/routes'

// Constants
import { BALANCE_LIMIT_TYPE, DOWNLOAD_TYPE } from '../../../constants'

// Modules
import { DI } from 'modules'

const DSAOneOffRestricted = ({ common, entity }) => {
  const { limit_type, subscriber_only } = entity

  const { strings } = common

  const buyPlanCln = 'side-buy-plan'
  const exclusivePrefix = 'page.video.slider.exclusive'
  const sliderPrefix = 'page.video.slider'

  return (
    <div className="download-block">
      <div className="download-plan download-plan--single">
        {subscriber_only ? (
          <div className={`${buyPlanCln}__text`}>
            {strings[`${exclusivePrefix}.content_restricted_msg_1`]}

            <a
              className="text-button"
              href={`mailto:${strings['clientdesk.email']}`}
            >
              c{strings['clientdesk.email']}
            </a>

            {strings[`${exclusivePrefix}.content_restricted_msg_2`]}
          </div>
        ) : (
          <>
            {limit_type === BALANCE_LIMIT_TYPE.POOL && (
              <div className={`${buyPlanCln}__text`}>
                {strings[`${sliderPrefix}.one_off.pool`]}
              </div>
            )}

            <div className={`${buyPlanCln}__info ${buyPlanCln}__info-padded`} />
            <div className="side-popup-line" />

            <div className={`${buyPlanCln}__text ${buyPlanCln}__text-padded`}>
              {strings[`${sliderPrefix}.one_off_info`]}
            </div>

            <Link
              className={`${buyPlanCln}__btn btn-bord`}
              to={choosePlan.getPath()}
            >
              {strings[`${sliderPrefix}.choose_plan`]}
            </Link>
          </>
        )}
      </div>
    </div>
  )
}

export default DI(['common'])(DSAOneOffRestricted)
